

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'passport-date-filter'
})
export default class PassportDateFilter extends Vue {
    @Prop({ default: null }) readonly programStartDate!: string | null;
    @Prop({ default: null }) readonly programEndDate!: string | null;
    @Prop({ default: null }) readonly selectedYearFromMainPage!: number | null;
    @Prop({ default: null }) readonly dateFromOtherTab!: string | null;
    @Prop({ default: true }) readonly isFromMainPage!: boolean;

    public selectedDate: Date | null = null;
    public tempSelectedDate: Date | null = null;
    public showModal: boolean = false;
    public currentCalendarMonth: number = new Date().getMonth();
    public currentCalendarYear: number = new Date().getFullYear();

    public weekdays: string[] = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];

    get displayDate(): string {
        if (this.selectedDate) {
            const day =  this.selectedDate.getDate();
            const month = String(this.selectedDate.getMonth() + 1).padStart(2, '0');
            const year = this.selectedDate.getFullYear();
            return `${day}.${month}.${year}`;
        }
        return '';
    }

    get monthYearDisplay(): string {
        const months = [
            'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
            'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
        ];
        return `${months[this.currentCalendarMonth]} ${this.currentCalendarYear}`;
    }

    get calendarDates() {
        const dates = [];
        const firstDay = new Date(this.currentCalendarYear, this.currentCalendarMonth, 1);
        const lastDay = new Date(this.currentCalendarYear, this.currentCalendarMonth + 1, 0);

        // Start from Monday (1) instead of Sunday (0)
        const startDate = new Date(firstDay);
        const dayOfWeek = firstDay.getDay();
        const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
        startDate.setDate(startDate.getDate() - daysToSubtract);

        // Generate 42 days (6 weeks)
        for (let i = 0; i < 42; i++) {
            const currentDate = new Date(startDate);
            currentDate.setDate(startDate.getDate() + i);

            const isInCurrentMonth = currentDate.getMonth() === this.currentCalendarMonth;
            const isToday = this.isSameDay(currentDate, new Date());
            const isSelected = this.tempSelectedDate ? this.isSameDay(currentDate, this.tempSelectedDate) : false;
            const isDisabled = this.isDateDisabled(currentDate);

            dates.push({
                key: `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`,
                day: currentDate.getDate(),
                date: new Date(currentDate),
                inCurrentMonth: isInCurrentMonth,
                isToday,
                isSelected,
                isDisabled
            });
        }

        return dates;
    }

    async mounted() {
        this.initializeDate();
    }

    private initializeDate() {
        if (!this.isFromMainPage && this.dateFromOtherTab) {
            // Случай 2: Переход с другой вкладки
            this.selectedDate = new Date(this.dateFromOtherTab);
        } else if (this.isFromMainPage && this.selectedYearFromMainPage) {
            // Случай 1: Переход с главной страницы
            this.selectedDate = this.getDefaultDateFromYear(this.selectedYearFromMainPage);
        } else {
            // Резервный вариант - текущая дата
            this.selectedDate = new Date();
        }

        if (this.selectedDate) {
            this.currentCalendarMonth = this.selectedDate.getMonth();
            this.currentCalendarYear = this.selectedDate.getFullYear();
        }
    }

    private getDefaultDateFromYear(year: number): Date {
        const currentYear = new Date().getFullYear();

        if (year === currentYear) {
            // Текущий год - текущая дата
            return new Date();
        } else if (year < currentYear) {
            // Прошлый год - 31.12.{год}
            return new Date(year, 11, 31);
        } else {
            // Будущий год - 01.01.{год}
            return new Date(year, 0, 1);
        }
    }

    private showDatePicker() {
        this.tempSelectedDate = this.selectedDate ? new Date(this.selectedDate) : new Date();
        if (this.tempSelectedDate) {
            this.currentCalendarMonth = this.tempSelectedDate.getMonth();
            this.currentCalendarYear = this.tempSelectedDate.getFullYear();
        }
        this.showModal = true;
    }

    private previousMonth() {
        if (this.currentCalendarMonth === 0) {
            this.currentCalendarMonth = 11;
            this.currentCalendarYear--;
        } else {
            this.currentCalendarMonth--;
        }
    }

    private nextMonth() {
        if (this.currentCalendarMonth === 11) {
            this.currentCalendarMonth = 0;
            this.currentCalendarYear++;
        } else {
            this.currentCalendarMonth++;
        }
    }

    private selectDate(dateObj: any) {
        if (dateObj.isDisabled) return;
        this.tempSelectedDate = new Date(dateObj.date);
    }

    private confirmDate() {
        if (this.tempSelectedDate) {
            this.selectedDate = new Date(this.tempSelectedDate);
            this.$emit('dateChanged', this.formatDateForEmit(this.selectedDate));
        }
        this.showModal = false;
    }

    private cancelDate() {
        this.showModal = false;
    }

    private applyFilter() {
        if (this.selectedDate) {
            this.$emit('dateChanged', this.formatDateForEmit(this.selectedDate));
        }
        // @ts-ignore
        this.$refs.drop.hide(true);
    }

    private resetFilter() {
        this.selectedDate = new Date();
        this.$emit('dateChanged', this.formatDateForEmit(this.selectedDate));
        // @ts-ignore
        this.$refs.drop.hide(true);
    }

    private isSameDay(date1: Date, date2: Date): boolean {
        return date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear();
    }

    private isDateDisabled(date: Date): boolean {
        if (this.programStartDate) {
            const startDate = new Date(this.programStartDate);
            if (date < startDate) return true;
        }

        if (this.programEndDate) {
            const endDate = new Date(this.programEndDate);
            if (date > endDate) return true;
        }

        return false;
    }

    private formatDateForEmit(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // Публичные методы
    public getSelectedDate(): string | null {
        return this.selectedDate ? this.formatDateForEmit(this.selectedDate) : null;
    }

    public setSelectedDate(date: string) {
        this.selectedDate = new Date(date);
    }

    @Watch('selectedYearFromMainPage')
    private onYearChange(newYear: number) {
        if (this.isFromMainPage && newYear) {
            this.selectedDate = this.getDefaultDateFromYear(newYear);
        }
    }

    @Watch('dateFromOtherTab')
    private onDateFromOtherTabChange(newDate: string) {
        if (!this.isFromMainPage && newDate) {
            this.selectedDate = new Date(newDate);
        }
    }
}
